var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSymbol = function SvgSymbol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB00",
    d: "M10.587454 23.060336H8.820842c-4.416528 0-8.010668 3.59414-8.010668 8.041127v24.032004c0 4.416528 3.59414 8.010668 8.010668 8.010668h1.766612c4.416528 0 8.010668-3.59414 8.010668-8.010668V31.101463c0-4.446987-3.59414-8.041127-8.010668-8.041127z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2979FF",
    d: "M55.1487.825401H31.055778c-4.446987 0-8.010668 3.59414-8.010668 8.010668v1.766612c0 4.416528 3.59414 8.010668 8.010668 8.010668h24.123381c4.416528 0 8.010668-3.59414 8.010668-8.010668V8.836069C63.159368 4.419541 59.565228.825401 55.1487.825401z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F80046",
    d: "M10.617913.825401H8.820843c-4.416528 0-8.010668 3.59414-8.010668 8.010668v1.766612c0 4.416528 3.59414 8.010668 8.010668 8.010668h1.766612c4.416528 0 8.010668-3.59414 8.010668-8.010668V8.83607c.030459-4.416528-3.533222-8.010668-7.980209-8.010668z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC3E",
    d: "M55.118241 23.060336H31.055778c-4.446987 0-8.010668 3.59414-8.010668 8.041127v24.062463c0 4.416528 3.59414 8.010668 8.010668 8.010668h24.062463c4.416528 0 8.010668-3.59414 8.010668-8.010668V31.101463c0-4.446987-3.59414-8.041127-8.010668-8.041127z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSymbol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/symbol.df30ff01.svg";
export { ForwardRef as ReactComponent };